import { Component, OnInit } from '@angular/core';
import { SettingsCategory } from '../../models/settings.model';
import { SettingsService } from '../../services/settings.service';
import { NgForOf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-settings-overview',
  standalone: true,
  imports: [NgForOf, RouterLink, MatIcon],
  templateUrl: './settings-overview.component.html',
  styleUrl: './settings-overview.component.scss',
})
export class SettingsOverviewComponent implements OnInit {
  public categories: SettingsCategory[] = [];

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.categories = this.settingsService.getCategories();
  }
}
